<script setup lang="ts">
import BetStatusButton from '@desktop/views/Relation/Sports/components/RelationView/Main/PocketIncidents/BetButton/BetStatusButton.vue'

import BetCardsButton from './BetCardsButton.vue'
import BetCornersButton from './BetCornersButton.vue'
</script>

<template>
  <BetStatusButton class="w-full" />
  <BetCardsButton />
  <BetCornersButton />
</template>
